import React from 'react';
import { Link } from '@tanstack/react-router';

const TimelineCreateVariantSelect: React.FC = () => {
  return (
    <div className="memory-variant-select-container inner">
      <div className="memory-variant-select-header">
        <div className="page-eyebrow">
          What would you like to create?
        </div>
      </div>
      <div className="wa-cluster wa-align-items-stretch memory-variant-select">
        <div className="memory-variant-type-select-item">
          <Link to="/memories/create" className="memory-variant-select-link">
            <div className="memory-variant-type-option">
              <div className="memory-variant-type-label">
                <h5><i className="fa-solid fa-bolt" /> SPRK</h5>
                <span>Capture a thought, feeling, or moment - and share it if you choose</span>
              </div>
            </div>
          </Link>
        </div>
        <div className="memory-variant-type-select-item">
          <Link to="/memories/create?variant=memory" className="memory-variant-select-link">
            <div className="memory-variant-type-option">
              <div className="memory-variant-type-label">
                <h5><i className="fa-regular fa-table-layout" /> Memory</h5>
                <span>Preserve one meaningful memory through words, photos, audio, or video</span>
              </div>
            </div>
          </Link>
        </div>
        <div className="memory-variant-type-select-item selected">
          <Link to="/timelines/create" className="memory-variant-select-link">
            <div className="memory-variant-type-option">
              <div className="memory-variant-type-label">
                <h5><i className="fa-regular fa-list-timeline" /> Timeline</h5>
                <span>Connect memories into a larger story that can grow over time and through others</span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TimelineCreateVariantSelect;
